import { useQuery } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useEngagementResource(id: string | undefined) {
  return useQuery({
    queryKey: engagementResourcesKeys.detail(id ?? ''),
    queryFn: () => {
      if (!id) throw new Error('missing id');
      return engagementResourcesService.get(id);
    },
    enabled: Boolean(id),
    // The detail response carries presigned S3 GET URLs for the video and
    // thumbnail. Those expire (~15 min on most buckets), and the global
    // query staleTime is 5 minutes — long enough for an admin sitting in
    // the edit form to end up with a dead URL after a refocus. Drop the
    // window to 30s so refetchOnWindowFocus reliably refreshes the URL
    // any time the tab regains focus during a long edit session.
    staleTime: 30_000,
  });
}
